<template>
  <div class="container-scroller">
    <div class="container-fluid page-body-wrapper full-page-wrapper">
      <div class="content-wrapper d-flex align-items-center auth">
        <div class="row flex-grow">
          <div class="col-lg-4 mx-auto">
            <div class="auth-form-light text-left p-5">
              <div class="brand-logo">
                <img src="../../assets/images/maxcess-logo.png" />
              </div>
              <h4>New here?</h4>
              <h6 class="font-weight-light">
                Signing up is easy. It only takes a few steps
              </h6>

              <BForm @submit.prevent="onSubmit" class="pt-3">
                <div class="form-group">
                  <BFormSelect
                    class="form-control form-select form-control-lg"
                    v-model="form.urm_id"
                    :options="ddlRole"
                    :state="is_valid_urm_id"
                    aria-describedby="input_error_urm_id"
                  />
                  <BFormInvalidFeedback id="input_error_urm_id">
                    Select Role
                  </BFormInvalidFeedback>
                </div>
                <div class="form-group">
                  <BFormInput
                    id="inline-form-input-name"
                    v-model="form.usr_user_name"
                    class="form-control form-control-lg"
                    placeholder="Username"
                    :state="is_valid_usr_user_name"
                    aria-describedby="input_error_usr_user_name"
                    maxlength="30"
                  />

                  <BFormInvalidFeedback id="input_error_usr_user_name">
                    Enter Username
                  </BFormInvalidFeedback>
                </div>
                <div class="form-group">
                  <BFormInput
                    id="inline-form-input-name"
                    v-model="form.usr_email"
                    class="form-control form-control-lg"
                    placeholder="Email"
                    :state="is_valid_usr_email"
                    aria-describedby="input_error_usr_email"
                    maxlength="200"
                  />
                  <BFormInvalidFeedback id="input_error_usr_email"
                    >{{ str_email_validation_msg }}
                  </BFormInvalidFeedback>
                </div>

                <div class="form-group">
                  <div class="mt-3">
                    <BInputGroup>
                      <template #append>
                        <BInputGroupText
                          style="font-size: 1.2rem"
                          @click="
                            showPass ? (showPass = false) : (showPass = true)
                          "
                          ><i
                            :class="
                              !showPass ? 'mdi mdi-eye-off' : 'mdi mdi-eye'
                            "
                          ></i>
                        </BInputGroupText>
                      </template>
                      <BFormInput
                        id="inline-form-input-name"
                        v-model="form.usr_entered_pass"
                        :type="showPass ? 'text' : 'password'"
                        class="form-control form-control-lg"
                        placeholder="Password"
                        :state="is_valid_usr_pass"
                        aria-describedby="input_error_user_pass"
                        title="Must contain at least one number and one uppercase and lowercase letter, and at most 8 characters"
                        @change="onChangePass($event)"
                        minlength="8"
                        maxlength="100"
                      />
                    </BInputGroup>
                    <BFormInvalidFeedback
                      id="input_error_user_pass"
                      style="display: block"
                      v-if="is_valid_usr_pass != null && !is_valid_usr_pass"
                    >
                      Enter password
                    </BFormInvalidFeedback>
                  </div>
                </div>
                <div class="form-group">
                  <div class="mt-3">
                    <BInputGroup>
                      <template #append>
                        <BInputGroupText
                          style="font-size: 1.2rem"
                          @click="
                            showConfirmPass
                              ? (showConfirmPass = false)
                              : (showConfirmPass = true)
                          "
                          ><i
                            :class="
                              !showConfirmPass
                                ? 'mdi mdi-eye-off'
                                : 'mdi mdi-eye'
                            "
                          ></i>
                        </BInputGroupText>
                      </template>
                      <BFormInput
                        id="input_error_confirm_pass"
                        v-model="form.usr_confirm_pass"
                        :type="showConfirmPass ? 'text' : 'password'"
                        class="form-control form-control-lg"
                        placeholder="Confirm Password"
                        :state="is_valid_usr_confirm_pass"
                        aria-describedby="input_error_user_pass"
                        title="Must contain at least one number and one uppercase and lowercase letter, and at most 8 characters"
                        @change="onChangePass($event)"
                        minlength="8"
                        maxlength="100"
                      />
                    </BInputGroup>
                    <BFormInvalidFeedback
                      id="input_error_confirm_pass"
                      style="display: block"
                      v-if="
                        is_valid_usr_confirm_pass != null &&
                        !is_valid_usr_confirm_pass
                      "
                    >
                      Enter confirm password
                    </BFormInvalidFeedback>
                  </div>
                </div>

                <div>
                  <ul class="requirements">
                    <li
                      v-for="(requirement, key) in passwordRequirements"
                      :key="key"
                      :class="requirement.predicate ? 'is-success' : 'is-error'"
                    >
                      {{ requirement.name }}
                    </li>
                  </ul>
                </div>
                <!-- <div
                  class="my-2 d-flex justify-content-between align-items-center text-muted"
                >
                  <BFormCheckbox
                    id="checkbox-1"
                    v-model="form.user_is_accepted_tc"
                    name="checkbox-1"
                    value="accepted"
                    unchecked-value="not_accepted"
                    :state="is_user_accepted_tc"
                  >
                    I agree to all Terms & Conditions
                  </BFormCheckbox>
                </div> -->
                <div class="mt-3">
                  <BButton
                    class="btn btn-block btn-gradient-primary btn-lg font-weight-medium auth-form-btn"
                    type="submit"
                    >Sign Up
                  </BButton>
                  <!-- to="/verify-otp" -->
                </div>
                <div class="text-center mt-4 font-weight-light">
                  Already have an account?
                  <router-link to="/" class="text-primary">Login</router-link>
                </div>
              </BForm>
            </div>
          </div>
        </div>
      </div>
      <!-- content-wrapper ends -->
    </div>
    <!-- page-body-wrapper ends -->
  </div>
</template>

<script setup>
/* eslint-disable */
import { computed, ref, onMounted } from "vue";
import axios from "axios";
import { useAuthStore } from "@/store/auth_store";
import { AESEncryptData } from "@/utils/common-function";
import { email_regex } from "@/main";

const is_valid_urm_id = ref(null);
const is_valid_usr_user_name = ref(null);
const is_valid_usr_pass = ref(null);
const is_valid_usr_confirm_pass = ref(null);
const is_valid_usr_email = ref(null);
// const is_user_accepted_tc = ref(null);
const str_email_validation_msg = ref("Enter Email");
const str_confirm_pass_val_msg = ref("Enter Confirm Password");

const ddlRole = ref([]);
const auth_store = useAuthStore();

const showPass = ref(false);
const showConfirmPass = ref(false);
// const email_regex = /^[A-Za-z0-9._%+-]+@maxcessintl\.(com|eu)$/;

onMounted(() => {
  getRoles();
});

function getRoles() {
  axios
    .get("/getRoles")
    .then((res) => {
      if (res.data != null && res.data.length > 0) {
        ddlRole.value.push({ value: -1, text: "Select Role" });
        res.data.forEach((element) => {
          if (element.url_role_code != "ADM" && element.url_role_code != "RST")
            ddlRole.value.push({
              value: element.url_id,
              text: element.url_role_desc,
            });
        });
      }
    })
    .catch((err) => {});
}
// const registed_user = ref({});

const form = ref({
  usr_id: null,
  usr_user_name: "",
  usr_email: "",
  usr_entered_pass: "",
  usr_password: "",
  usr_confirm_pass: "",
  urm_id: -1,
  usr_created_on: new Date(),
  usr_created_by: 1,
  usr_status: 0,
  usr_modified_on: null,
  usr_modified_by: null,
});

const passwordRequirements = computed(() => [
  {
    name: "Must contain uppercase letters",
    predicate:
      form.value.usr_entered_pass.toLowerCase() !== form.value.usr_entered_pass,
  },
  {
    name: "Must contain lowercase letters",
    predicate:
      form.value.usr_entered_pass.toUpperCase() !== form.value.usr_entered_pass,
  },
  {
    name: "Must contain numbers",
    predicate: /\d/.test(form.value.usr_entered_pass),
  },
  {
    name: "Must contain symbols",
    predicate: /\W/.test(form.value.usr_entered_pass),
  },
  {
    name: "Must be at least 8 characters long",
    predicate: form.value.usr_entered_pass.length >= 8,
  },
  {
    name: "Must match Password and Confirm Password",
    predicate:
      form.value.usr_confirm_pass != "" &&
      form.value.usr_entered_pass === form.value.usr_confirm_pass,
  },
]);

const onSubmit = async () => {
  if (validateFormInput()) {
    form.value.usr_password = AESEncryptData(form.value.usr_entered_pass);
    await auth_store.register(form);
  }
};

const validateFormInput = () => {
  // is_valid_urm_id.value = form.value.urm_id == '-1' ? false : true
  is_valid_urm_id.value = form.value.urm_id == -1 ? false : true;
  is_valid_usr_user_name.value = form.value.usr_user_name == "" ? false : true;
  is_valid_usr_email.value = form.value.usr_email == "" ? false : true;

  if (form.value.usr_email == "") {
    is_valid_usr_email.value = false;
  } else if (!email_regex.test(form.value.usr_email)) {
    is_valid_usr_email.value = false;
    str_email_validation_msg.value = "Enter valid Email";
  } else {
    is_valid_usr_email.value = true;
  }

  is_valid_usr_pass.value = form.value.usr_entered_pass == "" ? false : true;
  is_valid_usr_confirm_pass.value =
    form.value.usr_confirm_pass == "" ? false : true;
  if (form.value.usr_entered_pass !== form.value.usr_confirm_pass) {
    is_valid_usr_confirm_pass.value = false;
    str_confirm_pass_val_msg.value =
      "Password and confirm Password are mismatch";
  }
  is_valid_usr_user_name.value = form.value.usr_user_name == "" ? false : true;

  if (
    !is_valid_urm_id.value ||
    !is_valid_usr_user_name.value ||
    !is_valid_usr_email.value ||
    !is_valid_usr_pass.value ||
    !is_valid_usr_confirm_pass.value ||
    passwordRequirements.value.find((u) => u.predicate == false) != null
  )
    return false;
  else return true;
};

const onChangePass = (event) => {
  passwordRequirements,
    () => {
      passwordRequirements.value.reduce((v, p) => v && p.predicate, true);
    };
};
</script>

<style scoped>
.requirements {
  font-weight: 400;
}

.is-success {
  color: #96ca2d;
}

.is-error {
  color: #ba3637;
}
</style>
